module.exports = __webpack_public_path__ + "static/media/Motor.b0894bfe.mp3";